// Generated by scripts/build_reviewed_copy.py. Do not edit by hand.

export interface ReviewedInk {
  readonly text: string;
  readonly tone: "plain" | "key" | "value" | "custom";
  readonly color?: string;
}

export type ReviewedLine = readonly ReviewedInk[];

export interface ReviewedCardCopy {
  readonly name: string;
  readonly effect: string;
  readonly nameRuns: ReviewedLine;
  readonly lines: readonly ReviewedLine[];
}

export interface ReviewedRoleCopy {
  readonly name: string;
  readonly hp: number;
  readonly winCondition: string;
  readonly detail: string;
  readonly nameRuns: ReviewedLine;
  readonly lines: readonly ReviewedLine[];
}

export const REVIEWED_CARD_COPY = {
  "expanded_onbashira": {
    "name": "扩展御柱",
    "effect": "【装备】 你的攻击伤害【+1】。",
    "nameRuns": [
      {
        "text": "扩展御柱",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你的攻击伤害",
          "tone": "plain"
        },
        {
          "text": "【+1】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_eientei_heal": {
    "name": "永远亭的治疗",
    "effect": "【使用后舍弃】 给一名其他玩家回复【1d6】的伤害值。",
    "nameRuns": [
      {
        "text": "永远亭的治疗",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 给一名其他玩家回复",
          "tone": "plain"
        },
        {
          "text": "【1d6】",
          "tone": "value"
        },
        {
          "text": "的伤害值。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_eientei_malpractice": {
    "name": "永远亭的医疗事故",
    "effect": "【使用后舍弃】 将一名玩家的伤害值调至【7】。",
    "nameRuns": [
      {
        "text": "永远亭的医疗事故",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 将一名玩家的伤害值调至",
          "tone": "plain"
        },
        {
          "text": "【7】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_frog_snake_ornament": {
    "name": "蛙与蛇的发饰",
    "effect": "【装备】 【永远亭】的伤害效果对你无效。",
    "nameRuns": [
      {
        "text": "蛙与蛇的发饰",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " ",
          "tone": "plain"
        },
        {
          "text": "【永远亭】",
          "tone": "custom",
          "color": "#87ceeb"
        },
        {
          "text": "的伤害效果对你无效。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_gungnir": {
    "name": "神枪「冈格尼尔」",
    "effect": "【装备】 若你是自机阵营或【蕾米莉亚·斯卡雷特】：你可以不受【通常能力·限制】的影响而公开身份。公开身份后，你的攻击伤害【+2】。",
    "nameRuns": [
      {
        "text": "神枪「冈格尼尔」",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 若你是",
          "tone": "plain"
        },
        {
          "text": "自机阵营",
          "tone": "key"
        },
        {
          "text": "或",
          "tone": "plain"
        },
        {
          "text": "【蕾米莉亚·斯卡雷特】",
          "tone": "value"
        },
        {
          "text": "：你可以不受",
          "tone": "plain"
        },
        {
          "text": "【通常能力·限制】",
          "tone": "value"
        },
        {
          "text": "的影响而公开身份。公开身份后，你的攻击伤害",
          "tone": "plain"
        },
        {
          "text": "【+2】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_hakurouken": {
    "name": "白楼剑",
    "effect": "【装备】 当你击杀一名玩家后，你可以获得该玩家的全部装备。",
    "nameRuns": [
      {
        "text": "白楼剑",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 当你击杀一名玩家后，你可以获得该玩家的全部装备。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_incident_resolved": {
    "name": "异变解决",
    "effect": "【使用后舍弃】 如果你是自机阵营，你可以立刻公开身份并将伤害值置为【0】",
    "nameRuns": [
      {
        "text": "异变解决",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 如果你是",
          "tone": "plain"
        },
        {
          "text": "自机阵营",
          "tone": "key"
        },
        {
          "text": "，你可以立刻公开身份并将伤害值置为",
          "tone": "plain"
        },
        {
          "text": "【0】",
          "tone": "value"
        }
      ]
    ]
  },
  "hakurei_last_judgement": {
    "name": "审判「Last Judgement」",
    "effect": "【使用后舍弃】 除你以外，其他玩家受到【2】点伤害。",
    "nameRuns": [
      {
        "text": "审判「Last Judgement」",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 除你以外，其他玩家受到",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_offering_box": {
    "name": "博丽神社的赛钱箱",
    "effect": "【装备】 守矢神社卡造成的伤害对你无效",
    "nameRuns": [
      {
        "text": "博丽神社的赛钱箱",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 守矢神社卡造成的伤害对你无效",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_pad": {
    "name": "外界的****",
    "effect": "【装备】 你造成的攻击伤害【-1】。你受到的攻击伤害【-1】。",
    "nameRuns": [
      {
        "text": "外界的****",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你造成的攻击伤害",
          "tone": "plain"
        },
        {
          "text": "【-1】",
          "tone": "value"
        },
        {
          "text": "。你受到的攻击伤害",
          "tone": "plain"
        },
        {
          "text": "【-1】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_pendulum": {
    "name": "灵摆",
    "effect": "【装备】 移动时，你可以多投掷一次骰子，并在投掷的结果中选择一处进行移动。",
    "nameRuns": [
      {
        "text": "灵摆",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 移动时，你可以多投掷一次骰子，并在投掷的结果中选择一处进行移动。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_pocket_watch": {
    "name": "咲夜的怀表",
    "effect": "【使用后舍弃】 本回合结束后，你立即进行一个额外的回合。",
    "nameRuns": [
      {
        "text": "咲夜的怀表",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 本回合结束后，你立即进行一个额外的回合。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_sake": {
    "name": "酒",
    "effect": "【使用后舍弃】 回复【2】点伤害值。",
    "nameRuns": [
      {
        "text": "酒",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 回复",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_sangetsu_hideout": {
    "name": "三月精的隐蔽处",
    "effect": "【使用后舍弃】 直到你的下次移动开始，你不受攻击造成的伤害。",
    "nameRuns": [
      {
        "text": "三月精的隐蔽处",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 直到你的下次移动开始，你不受攻击造成的伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_satori_third_eye": {
    "name": "觉的第三只眼睛",
    "effect": "【使用后舍弃】 若你是BOSS阵营（【封兽鵺】除外），则你必须立即公开你的身份。",
    "nameRuns": [
      {
        "text": "觉的第三只眼睛",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 若你是",
          "tone": "plain"
        },
        {
          "text": "BOSS阵营",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "（【封兽鵺】除外），则你必须立即公开你的身份。",
          "tone": "plain"
        }
      ]
    ]
  },
  "hakurei_shaved_ice": {
    "name": "琪露诺的刨冰",
    "effect": "【使用后舍弃】 若你是：\n自机阵营或BOSS阵营：【HP:10】及以下。\n野次马阵营：【HP:9】及以下。\n则你可以立刻公开身份并将你的伤害值置为【0】。",
    "nameRuns": [
      {
        "text": "琪露诺的刨冰",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 若你是：",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "自机阵营",
          "tone": "key"
        },
        {
          "text": "或",
          "tone": "plain"
        },
        {
          "text": "BOSS阵营",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "：",
          "tone": "plain"
        },
        {
          "text": "【HP:10】",
          "tone": "value"
        },
        {
          "text": "及以下。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "野次马阵营",
          "tone": "custom",
          "color": "#2f9b67"
        },
        {
          "text": "：",
          "tone": "plain"
        },
        {
          "text": "【HP:9】",
          "tone": "value"
        },
        {
          "text": "及以下。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "则你可以立刻公开身份并将你的伤害值置为",
          "tone": "plain"
        },
        {
          "text": "【0】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_a1": {
    "name": "你是自机阵营或BOSS阵营吗？",
    "effect": "若是的话，受到【1】点伤害哦",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "自机阵营",
        "tone": "key"
      },
      {
        "text": "或",
        "tone": "plain"
      },
      {
        "text": "BOSS阵营",
        "tone": "custom",
        "color": "#8759c7"
      },
      {
        "text": "吗？",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害哦",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_a2": {
    "name": "你是自机阵营或野次马阵营吗？",
    "effect": "若是的话，受到【1】点伤害哦",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "自机阵营",
        "tone": "key"
      },
      {
        "text": "或",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "custom",
        "color": "#2f9b67"
      },
      {
        "text": "吗？",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害哦",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_a3": {
    "name": "你是BOSS阵营或野次马阵营吗？",
    "effect": "若是的话，受到【1】点伤害哦",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "BOSS阵营",
        "tone": "custom",
        "color": "#8759c7"
      },
      {
        "text": "或",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "key"
      },
      {
        "text": "吗？",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害哦",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_b1": {
    "name": "你的现有HP在13及以上吗?",
    "effect": "若是的话，受到【1】点伤害哦",
    "nameRuns": [
      {
        "text": "你的现有HP在",
        "tone": "plain"
      },
      {
        "text": "13",
        "tone": "value"
      },
      {
        "text": "及以上吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害哦",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_b2": {
    "name": "你的现有HP在10及以下吗?",
    "effect": "如果是的话，回复【1】点体力哦~\n......不是吗？\n那就受到【1】点伤害喵~",
    "nameRuns": [
      {
        "text": "你的现有HP在10及以下吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "如果是的话，回复",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点体力哦~",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "......不是吗？",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害喵~",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_c1": {
    "name": "你是自机阵营吗?",
    "effect": "若是的话，给我受到【1】点伤害！\n如果你的当前HP在12以上\n那就再受到【1】点伤害！",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "自机阵营",
        "tone": "key"
      },
      {
        "text": "吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，给我受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害！",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "如果你的当前HP在",
          "tone": "plain"
        },
        {
          "text": "12",
          "tone": "value"
        },
        {
          "text": "以上",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就再受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害！",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_c2": {
    "name": "你是BOSS阵营吗?",
    "effect": "若是的话，给我受到【1】点伤害！\n如果你的当前HP在12以上\n那就再受到【1】点伤害！",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "BOSS阵营",
        "tone": "custom",
        "color": "#8759c7"
      },
      {
        "text": "吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，给我受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害！",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "如果你的当前HP在",
          "tone": "plain"
        },
        {
          "text": "12",
          "tone": "value"
        },
        {
          "text": "以上",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就再受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害！",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_c3": {
    "name": "你是野次马阵营吗?",
    "effect": "若是的话，给我受到【1】点伤害！\n如果你的当前HP在12以上\n那就再受到【1】点伤害！",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "custom",
        "color": "#2f9b67"
      },
      {
        "text": "吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，给我受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害！",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "如果你的当前HP在",
          "tone": "plain"
        },
        {
          "text": "12",
          "tone": "value"
        },
        {
          "text": "以上",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就再受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害！",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_d1": {
    "name": "你是野次马阵营的话请遵循以下指示：",
    "effect": "当前HP在10以下：回复【2】点伤害值\n当前HP在11以上：回复【1】点伤害值。\n若你当前的伤害值为0，则不进行回复改为受到【1】点伤害。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "custom",
        "color": "#2f9b67"
      },
      {
        "text": "的话请遵循以下指示：",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "10",
          "tone": "value"
        },
        {
          "text": "以下：回复",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害值",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "11",
          "tone": "value"
        },
        {
          "text": "以上：回复",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若你当前的伤害值为0，则不进行回复改为受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_d2": {
    "name": "你是自机阵营或野次马阵营的话请遵循以下指示：",
    "effect": "当前HP在11以下：回复【2】点伤害值。\n当前HP在12以上：回复【1】点伤害值。\n若你当前的伤害值为0，则不进行回复改为受到【1】点伤害。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "自机阵营",
        "tone": "key"
      },
      {
        "text": "或",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "custom",
        "color": "#2f9b67"
      },
      {
        "text": "的话请遵循以下指示：",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "11",
          "tone": "value"
        },
        {
          "text": "以下：回复",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "12",
          "tone": "value"
        },
        {
          "text": "以上：回复",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若你当前的伤害值为0，则不进行回复改为受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_d3": {
    "name": "你是BOSS阵营或野次马阵营的话请遵循以下指示：",
    "effect": "当前HP在11以下：回复【2】点伤害值。\n当前HP在12以上：回复【1】点伤害值。\n若你当前的伤害值为0，则不进行回复改为受到【1】点伤害。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "BOSS阵营",
        "tone": "key"
      },
      {
        "text": "或",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "custom",
        "color": "#2f9b67"
      },
      {
        "text": "的话请遵循以下指示：",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "11",
          "tone": "value"
        },
        {
          "text": "以下：回复",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "12",
          "tone": "value"
        },
        {
          "text": "以上：回复",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若你当前的伤害值为0，则不进行回复改为受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_d4": {
    "name": "你是BOSS阵营或自机阵营的话请遵循以下指示",
    "effect": "当前HP在11以下：回复【2】点伤害值。\n当前HP在12以上：回复【1】点伤害值。\n若你当前的伤害值为0，则不进行回复改为受到【1】点伤害。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "BOSS阵营",
        "tone": "custom",
        "color": "#8759c7"
      },
      {
        "text": "或",
        "tone": "plain"
      },
      {
        "text": "自机阵营",
        "tone": "key"
      },
      {
        "text": "的话请遵循以下指示",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "11",
          "tone": "value"
        },
        {
          "text": "以下：回复",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "当前HP在",
          "tone": "plain"
        },
        {
          "text": "12",
          "tone": "value"
        },
        {
          "text": "以上：回复",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害值。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若你当前的伤害值为0，则不进行回复改为受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_e1": {
    "name": "你是自机阵营吗?",
    "effect": "若是的话，你要交给我一件装备，\n（若没有装备则受到【1】点伤害）\n......什么？不是吗？\n那就拿走我的一件装备吧。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "自机阵营",
        "tone": "key"
      },
      {
        "text": "吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，你要交给我一件装备，",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "（若没有装备则受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害）",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "......什么？不是吗？",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就拿走我的一件装备吧。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_e2": {
    "name": "你是BOSS阵营吗?",
    "effect": "若是的话，你要交给我一件装备，\n（若没有装备则受到【1】点伤害）\n......什么？不是吗？\n那就拿走我的一件装备吧。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "BOSS阵营",
        "tone": "custom",
        "color": "#8759c7"
      },
      {
        "text": "吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，你要交给我一件装备，",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "（若没有装备则受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害）",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "......什么？不是吗？",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就拿走我的一件装备吧。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_e3": {
    "name": "你是野次马阵营吗?",
    "effect": "若是的话，你要交给我一件装备，\n（若没有装备则受到【1】点伤害）\n......什么？不是吗？\n那就拿走我的一件装备吧。",
    "nameRuns": [
      {
        "text": "你是",
        "tone": "plain"
      },
      {
        "text": "野次马阵营",
        "tone": "custom",
        "color": "#2f9b67"
      },
      {
        "text": "吗?",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "若是的话，你要交给我一件装备，",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "（若没有装备则受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害）",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "......什么？不是吗？",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "那就拿走我的一件装备吧。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_hourin_scripture": {
    "name": "法力经典",
    "effect": "【装备】这张牌发给其他玩家时没有效果，当你获得这张牌的时候，你可以将其置于你的装备区内。\n若这张牌在你的装备区内，在你的回合开始时，你从牌山中获得一张命莲寺卡，且必须立即使用。",
    "nameRuns": [
      {
        "text": "法力经典",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": "这张牌发给其他玩家时没有效果，当你获得这张牌的时候，你可以将其置于你的装备区内。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若这张牌在你的装备区内，在你的回合开始时，你从牌山中获得一张命莲寺卡，且必须立即使用。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kleinji_namusam": {
    "name": "这张卡适用于所有角色",
    "effect": "包括封兽鵺在内的一切正体不明之物！\n向我展示你的真身吧！南无三——\n（你必须将你的角色卡交给递给你此卡的人物）",
    "nameRuns": [
      {
        "text": "这张卡适用于所有角色",
        "tone": "value"
      }
    ],
    "lines": [
      [
        {
          "text": "包括封兽鵺在内的一切正体不明之物！",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "向我展示你的真身吧！南无三——",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "（你必须将你的角色卡交给递给你此卡的人物）",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_cursed_doll": {
    "name": "诅咒的毒人偶",
    "effect": "【使用后舍弃】 你须指定一名其他玩家并投掷一次六面骰，按结果发动以下效果：\n1~4：对方受到【3】点伤害。\n5~6：自己受到【3】点伤害。",
    "nameRuns": [
      {
        "text": "诅咒的毒人偶",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 你须指定一名其他玩家并投掷一次六面骰，按结果发动以下效果：",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "1~4：对方受到",
          "tone": "plain"
        },
        {
          "text": "【3】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "5~6：自己受到",
          "tone": "plain"
        },
        {
          "text": "【3】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_hisou_sword": {
    "name": "绯想之剑",
    "effect": "【装备】 你的攻击伤害【+1】。",
    "nameRuns": [
      {
        "text": "绯想之剑",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你的攻击伤害",
          "tone": "plain"
        },
        {
          "text": "【+1】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_incident_occurs": {
    "name": "异变发生",
    "effect": "【使用后舍弃】 若你是BOSS阵营，你可以立刻公开身份并将伤害值调至【0】。",
    "nameRuns": [
      {
        "text": "异变发生",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 若你是",
          "tone": "plain"
        },
        {
          "text": "BOSS阵营",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "，你可以立刻公开身份并将伤害值调至",
          "tone": "plain"
        },
        {
          "text": "【0】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_kaguya_treasure": {
    "name": "辉夜的宝物收集",
    "effect": "【使用后舍弃】 你可以获得场上的一件装备。",
    "nameRuns": [
      {
        "text": "辉夜的宝物收集",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 你可以获得场上的一件装备。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_little_devil": {
    "name": "出现失误的小恶魔",
    "effect": "【使用后舍弃】 你须将你的一件装备交给一名其他玩家。\n若你没有装备，则你受到【1】点伤害。",
    "nameRuns": [
      {
        "text": "出现失误的小恶魔",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 你须将你的一件装备交给一名其他玩家。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若你没有装备，则你受到",
          "tone": "plain"
        },
        {
          "text": "【1】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_master_spark": {
    "name": "恋符「Master Spark」",
    "effect": "【装备】 你可以攻击到你攻击领域内的全部目标，自己也会受到伤害。",
    "nameRuns": [
      {
        "text": "恋符「Master Spark」",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你可以攻击到你攻击领域内的全部目标，自己也会受到伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_patchouli_magic": {
    "name": "帕秋莉的大魔法",
    "effect": "【使用后舍弃】 你令自己和一名你指定的其他玩家同时受到【2】点伤害。",
    "nameRuns": [
      {
        "text": "帕秋莉的大魔法",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 你令自己和一名你指定的其他玩家同时受到",
          "tone": "plain"
        },
        {
          "text": "【2】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_phoenix": {
    "name": "不死「火鸟　-凤翼天翔-」",
    "effect": "【装备】 你的攻击伤害改为1d4。\n若你有攻击目标，则你必须攻击。",
    "nameRuns": [
      {
        "text": "不死「火鸟　-凤翼天翔-」",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你的攻击伤害改为1d4。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "若你有攻击目标，则你必须攻击。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_poet_and_animal": {
    "name": "歌仙和动物",
    "effect": "【装备】 你将你的攻击范围修改为：\n可以攻击到领域外的目标，不能攻击到领域内的目标。",
    "nameRuns": [
      {
        "text": "歌仙和动物",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你将你的攻击范围修改为：",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "可以攻击到领域外的目标，不能攻击到领域内的目标。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_reaper_scythe": {
    "name": "死神镰刀",
    "effect": "【装备】 你的攻击伤害【+1】。",
    "nameRuns": [
      {
        "text": "死神镰刀",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【装备】",
          "tone": "value"
        },
        {
          "text": " 你的攻击伤害",
          "tone": "plain"
        },
        {
          "text": "【+1】",
          "tone": "value"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_servant_flier": {
    "name": "Servant flier",
    "effect": "【使用后舍弃】 你对一名玩家造成2点伤害，随后你回复1点体力。",
    "nameRuns": [
      {
        "text": "Servant flier",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 你对一名玩家造成2点伤害，随后你回复1点体力。",
          "tone": "plain"
        }
      ]
    ]
  },
  "moriya_underground_rose": {
    "name": "地底蔷薇",
    "effect": "【使用后舍弃】 你投掷一次两颗骰子，并令二者结果之和对应的场所中的所有玩家受到【3】点伤害。",
    "nameRuns": [
      {
        "text": "地底蔷薇",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【使用后舍弃】",
          "tone": "value"
        },
        {
          "text": " 你投掷一次两颗骰子，并令二者结果之和对应的场所中的所有玩家受到",
          "tone": "plain"
        },
        {
          "text": "【3】",
          "tone": "value"
        },
        {
          "text": "点伤害。",
          "tone": "plain"
        }
      ]
    ]
  }
} as const satisfies Record<string, ReviewedCardCopy>;

export const REVIEWED_ROLE_COPY = {
  "cirno": {
    "name": "琪露诺",
    "hp": 9,
    "winCondition": "游戏结束时你存活",
    "detail": "【特殊能力】 雪符「钻石风暴」\n若可以攻击则必须攻击。\n【特殊能力】冻符「急冻大气」\n当你的伤害值大于等于9时，你可以立刻公开身份。若因为此效果而公开身份，你将伤害值归零。",
    "nameRuns": [
      {
        "text": "琪露诺",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】游戏结束时你存活",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "雪符「钻石风暴」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "若可以攻击则必须攻击。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "冻符「急冻大气」",
          "tone": "value"
        },
        {
          "text": " ",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "当你的伤害值大于等于9时，你可以立刻公开身份。若因为此效果而公开身份，你将伤害值归零。",
          "tone": "plain"
        }
      ]
    ]
  },
  "eirin": {
    "name": "八意永琳",
    "hp": 8,
    "winCondition": "右邻玩家胜利",
    "detail": "【特殊能力】 苏活「生命游戏」（仅限1次）\n将一名玩家的伤害值调到7。\n【特殊能力】苏生「Rising Game」\n不受博丽神社卡和永远亭的影响。当其他玩家受到博丽神社卡和永远亭的影响时，你也可以受到同样的影响。\n【特殊能力】天丸「壶中的天地」（仅限1次)\n你的回合开始时，你可以将胜利条件修改为「左邻玩家获胜」。",
    "nameRuns": [
      {
        "text": "八意永琳",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "右邻",
          "tone": "custom",
          "color": "#87ceeb"
        },
        {
          "text": "玩家胜利",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": " 苏活「生命游戏」",
          "tone": "value"
        },
        {
          "text": "（仅限1次）",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "将一名玩家的伤害值调到7。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "苏生「Rising Game」 ",
          "tone": "value"
        }
      ],
      [
        {
          "text": "不受",
          "tone": "plain"
        },
        {
          "text": "博丽神社卡",
          "tone": "value"
        },
        {
          "text": "和",
          "tone": "plain"
        },
        {
          "text": "永远亭",
          "tone": "custom",
          "color": "#87ceeb"
        },
        {
          "text": "的影响。当其他玩家受到",
          "tone": "plain"
        },
        {
          "text": "博丽神社卡",
          "tone": "value"
        },
        {
          "text": "和",
          "tone": "plain"
        },
        {
          "text": "永远亭",
          "tone": "custom",
          "color": "#87ceeb"
        },
        {
          "text": "的影响时，你也可以受到同样的影响。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "天丸「壶中的天地」（仅限1次)",
          "tone": "value"
        }
      ],
      [
        {
          "text": "你的回合开始时，你可以将胜利条件修改为「",
          "tone": "plain"
        },
        {
          "text": "左邻",
          "tone": "custom",
          "color": "#87ceeb"
        },
        {
          "text": "玩家获胜」。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kaguya": {
    "name": "蓬莱山辉夜",
    "hp": 10,
    "winCondition": "收集4件装备牌。",
    "detail": "【特殊能力】 新难题「金阁寺的天花板」\n有玩家死亡时，你可以获取该玩家的一件装备。若这名玩家是由你击杀的，则你可以获得该玩家的全部装备。",
    "nameRuns": [
      {
        "text": "蓬莱山辉夜",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】收集4件装备牌。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "新难题「金阁寺的天花板」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "有玩家死亡时，你可以获取该玩家的一件装备。若这名玩家是由你击杀的，则你可以获得该玩家的全部装备。",
          "tone": "plain"
        }
      ]
    ]
  },
  "kanako": {
    "name": "八坂神奈子",
    "hp": 12,
    "winCondition": "你杀死了HP上限为13及以上的玩家或游戏结束时你在守矢神社。",
    "detail": "【通常能力】 当你杀死了HP上限为12及以下的玩家时，你必须公开自己的身份。\n你的回合开始时，若你没有装备【扩展御柱】，则你不能公开自己的身份。\n【特殊能力】筒粥「神之粥」\n如果你不是因为通常能力公开自己的角色的话，并且持有装备【扩展御柱】时，胜利条件追加【游戏结束时你身处守矢神社所在领域】",
    "nameRuns": [
      {
        "text": "八坂神奈子",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】你杀死了HP上限为13及以上的玩家或游戏结束时你在",
          "tone": "plain"
        },
        {
          "text": "守矢神社",
          "tone": "custom",
          "color": "#2f9b67"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【通常能力】 当你杀死了HP上限为12及以下的玩家时，你必须公开自己的身份。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "你的回合开始时，若你没有装备【扩展御柱】，则你不能公开自己的身份。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "筒粥「神之粥」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "如果你不是因为通常能力公开自己的角色的话，并且持有装备【扩展御柱】时，胜利条件追加【游戏结束时你身处",
          "tone": "plain"
        },
        {
          "text": "守矢神社",
          "tone": "custom",
          "color": "#2f9b67"
        },
        {
          "text": "所在领域】",
          "tone": "plain"
        }
      ]
    ]
  },
  "komachi": {
    "name": "小野冢小町",
    "hp": 11,
    "winCondition": "在至少三分之一玩家（向下取整）死亡后， 你的攻击造成击杀。",
    "detail": "【特殊能力】死神「彼岸归航」\n在你进行攻击之后，对自己造成2点伤害，再攻击一次刚才攻击过的玩家。",
    "nameRuns": [
      {
        "text": "小野冢小町",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】在至少三分之一玩家（向下取整）死亡后， 你的攻击造成击杀。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "死神「彼岸归航」",
          "tone": "value"
        },
        {
          "text": " ",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "在你进行攻击之后，对自己造成2点伤害，再攻击一次刚才攻击过的玩家。",
          "tone": "plain"
        }
      ]
    ]
  },
  "marisa": {
    "name": "雾雨魔理沙",
    "hp": 12,
    "winCondition": "Boss方全灭",
    "detail": "【特殊能力】 恋符 「Master Spark」\n你的回合开始时，你可以投掷一次六面骰，对一名其他玩家造成与结果相同的伤害并记录总伤害点数。总伤害点数 超过6时（超过不补足），该特殊能力失效。",
    "nameRuns": [
      {
        "text": "雾雨魔理沙",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "Boss方",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "全灭",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "恋符 「Master Spark」",
          "tone": "value"
        },
        {
          "text": " ",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "你的回合开始时，你可以投掷一次六面骰，对一名其他玩家造成与结果相同的伤害并记录总伤害点数。总伤害点数 超过6时（超过不补足），该特殊能力失效。",
          "tone": "plain"
        }
      ]
    ]
  },
  "nue": {
    "name": "封兽鵺",
    "hp": 11,
    "winCondition": "自机方全灭或杀死第3名及以上的野次马。",
    "detail": "【通常能力】你可以不遵循命莲寺卡的指示。\n【特殊能力】 恨弓「源三位赖政之弓」\n你的回合内，你可以对一名其他玩家造成1点伤害。若这是你本局游戏中第一次使用该能力，则你可以将伤害改为回复。",
    "nameRuns": [
      {
        "text": "封兽鵺",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "自机方",
          "tone": "key"
        },
        {
          "text": "全灭或杀死第3名及以上的",
          "tone": "plain"
        },
        {
          "text": "野次马",
          "tone": "custom",
          "color": "#2f9b67"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【通常能力】你可以不遵循",
          "tone": "plain"
        },
        {
          "text": "命莲寺",
          "tone": "custom",
          "color": "#87ceeb"
        },
        {
          "text": "卡的指示。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "恨弓「源三位赖政之弓」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "你的回合内，你可以对一名其他玩家造成1点伤害。若这是你本局游戏中第一次使用该能力，则你可以将伤害改为回复。",
          "tone": "plain"
        }
      ]
    ]
  },
  "parsee": {
    "name": "水桥帕露西",
    "hp": 11,
    "winCondition": "你是第一名死亡的玩家或你存活到场上只剩两人。",
    "detail": "【特殊能力】花开爷爷「对华丽的仁者之嫉妒」\n如果你的伤害值不是所有角色中最低的，在回合开始时可以回复1点伤害值。",
    "nameRuns": [
      {
        "text": "水桥帕露西",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】你是第一名死亡的玩家或你存活到场上只剩两人。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "花开爷爷「对华丽的仁者之嫉妒」 ",
          "tone": "value"
        }
      ],
      [
        {
          "text": "如果你的伤害值不是所有角色中最低的，在回合开始时可以回复1点伤害值。",
          "tone": "plain"
        }
      ]
    ]
  },
  "reimu": {
    "name": "博丽灵梦",
    "hp": 11,
    "winCondition": "Boss方全灭",
    "detail": "【特殊能力】 灵符「梦想封印」\n攻击时，你可以调整其中一个骰子的结果。(仅限1次)\n【特殊能力】神灵「梦想封印瞬」\n移动时，你可以放弃投掷骰子，改为移动到相邻场所。(仅限1次)",
    "nameRuns": [
      {
        "text": "博丽灵梦",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "Boss方",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "全灭",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "灵符「梦想封印」",
          "tone": "value"
        },
        {
          "text": " ",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "攻击时，你可以调整其中一个骰子的结果。(仅限1次) ",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "神灵「梦想封印瞬」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "移动时，你可以放弃投掷骰子，改为移动到相邻场所。(仅限1次)",
          "tone": "plain"
        }
      ]
    ]
  },
  "remilia": {
    "name": "蕾米莉亚",
    "hp": 13,
    "winCondition": "自机方全灭或杀死第3名及以上的野次马。",
    "detail": "【通常能力】 当你的伤害值在9以下时，你不能公开你的身份\n如果受到了「servant flier」的伤害，你可以在该回合马上公开身份。\n【特殊能力】 神术「吸血鬼幻想」\n你的攻击造成伤害后，你回复2点伤害值。",
    "nameRuns": [
      {
        "text": "蕾米莉亚",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "自机方",
          "tone": "key"
        },
        {
          "text": "全灭或杀死第3名及以上的",
          "tone": "plain"
        },
        {
          "text": "野次马",
          "tone": "custom",
          "color": "#2f9b67"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【通常能力】 当你的伤害值在9以下时，你不能公开你的身份",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "如果受到了",
          "tone": "plain"
        },
        {
          "text": "「servant flier」",
          "tone": "value"
        },
        {
          "text": "的伤害，你可以在该回合马上公开身份。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "神术「吸血鬼幻想」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "你的攻击造成伤害后，你回复2点伤害值。",
          "tone": "plain"
        }
      ]
    ]
  },
  "sakuya": {
    "name": "十六夜咲夜",
    "hp": 14,
    "winCondition": "Boss方全灭",
    "detail": "【特殊能力】 奇术「永恒的温柔」(仅限1次)\n1、你的回合开始时，你可以选择一项： 对一名其他玩家造成一次1d4的伤害。\n2、获取场上的一件装备。",
    "nameRuns": [
      {
        "text": "十六夜咲夜",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "Boss方",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "全灭",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": " 奇术「永恒的温柔」",
          "tone": "value"
        },
        {
          "text": "(仅限1次)",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "1、你的回合开始时，你可以选择一项： 对一名其他玩家造成一次1d4的伤害。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "2、获取场上的一件装备。",
          "tone": "plain"
        }
      ]
    ]
  },
  "sanae": {
    "name": "东风谷早苗",
    "hp": 11,
    "winCondition": "Boss方全灭",
    "detail": "【特殊能力】 奇迹「神秘果」\n攻击时你选择一项：\n1、正常攻击。\n2、对一名玩家治疗等于本次攻击伤害的伤害值。",
    "nameRuns": [
      {
        "text": "东风谷早苗",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "Boss方",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "全灭",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "奇迹「神秘果」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "攻击时你选择一项：",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "1、正常攻击。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "2、对一名玩家治疗等于本次攻击伤害的伤害值。",
          "tone": "plain"
        }
      ]
    ]
  },
  "utsuho": {
    "name": "灵乌路空",
    "hp": 11,
    "winCondition": "自机方全灭或杀死第3名及以上的野次马。",
    "detail": "【特殊能力】 爆符「千兆耀斑」\n你的回合内，你可以指定一个场所，并对该场所中所有玩家造成1点伤害。\n【特殊能力】核热「核反应执御不能」（仅限1次）\n同时投掷两枚骰子，对二者结果之和对应的场地中所有玩家造成3点伤害。你可以在投掷之后防止此伤害。",
    "nameRuns": [
      {
        "text": "灵乌路空",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "自机方",
          "tone": "key"
        },
        {
          "text": "全灭或杀死第3名及以上的",
          "tone": "plain"
        },
        {
          "text": "野次马",
          "tone": "custom",
          "color": "#2f9b67"
        },
        {
          "text": "。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "爆符「千兆耀斑」 ",
          "tone": "value"
        }
      ],
      [
        {
          "text": "你的回合内，你可以指定一个场所，并对该场所中所有玩家造成1点伤害。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】",
          "tone": "plain"
        },
        {
          "text": "核热「核反应执御不能」",
          "tone": "value"
        },
        {
          "text": "（仅限1次）",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "同时投掷两枚骰子，对二者结果之和对应的场地中所有玩家造成3点伤害。你可以在投掷之后防止此伤害。",
          "tone": "plain"
        }
      ]
    ]
  },
  "youmu": {
    "name": "魂魄妖梦",
    "hp": 13,
    "winCondition": "Boss方全灭",
    "detail": "【通常能力】当且仅当你的伤害值在【4,5,6,8,9】时，你 可以公开你的身份。\n【特殊能力】 「待宵反射卫星斩」\n当你受到攻击伤害后，你可以立即对伤害来源进行一次反击。反击时不能使用装备，你濒死时不可以使用这个能力。",
    "nameRuns": [
      {
        "text": "魂魄妖梦",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "Boss方",
          "tone": "custom",
          "color": "#8759c7"
        },
        {
          "text": "全灭",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【通常能力】当且仅当你的伤害值在【4,5,6,8,9】时，你 可以公开你的身份。",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "「待宵反射卫星斩」",
          "tone": "value"
        }
      ],
      [
        {
          "text": "当你受到攻击伤害后，你可以立即对伤害来源进行一次反击。反击时不能使用装备，你濒死时不可以使用这个能力。",
          "tone": "plain"
        }
      ]
    ]
  },
  "yukari": {
    "name": "八云紫",
    "hp": 12,
    "winCondition": "自机方全灭或杀死第3名及以上的野次马",
    "detail": "【通常能力】你的伤害值在8，9时，你必须公开你的身份\n【特殊能力】 紫奥义「弹幕结界」 你的攻击不受领域的限制",
    "nameRuns": [
      {
        "text": "八云紫",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "自机方",
          "tone": "key"
        },
        {
          "text": "全灭或杀死第3名及以上的",
          "tone": "plain"
        },
        {
          "text": "野次马",
          "tone": "custom",
          "color": "#2f9b67"
        }
      ],
      [
        {
          "text": "【通常能力】你的伤害值在8，9时，你必须公开你的身份",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "紫奥义「弹幕结界」",
          "tone": "value"
        },
        {
          "text": " 你的攻击不受领域的限制",
          "tone": "plain"
        }
      ]
    ]
  },
  "yuyuko": {
    "name": "西行寺幽幽子",
    "hp": 14,
    "winCondition": "自机方全灭或杀死第3名及以上的野次马",
    "detail": "【特殊能力】 樱符「完全墨染的樱花」\n你可以追加进行X个回合。（X为死亡玩家的数量）",
    "nameRuns": [
      {
        "text": "西行寺幽幽子",
        "tone": "plain"
      }
    ],
    "lines": [
      [
        {
          "text": "【胜利条件】",
          "tone": "plain"
        },
        {
          "text": "自机方",
          "tone": "key"
        },
        {
          "text": "全灭或杀死第3名及以上的",
          "tone": "plain"
        },
        {
          "text": "野次马",
          "tone": "custom",
          "color": "#2f9b67"
        }
      ],
      [
        {
          "text": "【特殊能力】 ",
          "tone": "plain"
        },
        {
          "text": "樱符「完全墨染的樱花」",
          "tone": "value"
        },
        {
          "text": " ",
          "tone": "plain"
        }
      ],
      [
        {
          "text": "你可以追加进行X个回合。（X为死亡玩家的数量）",
          "tone": "plain"
        }
      ]
    ]
  }
} as const satisfies Record<string, ReviewedRoleCopy>;
